
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitoaurangabadcab() {



    const cardData =
    {
        keyword: ' Mumbai to Aurangabad Cab',
        heading: 'Deva Cabs:  Mumbai to Aurangabad Cab',
        headingDescription: 'Deva Cabs offers reliable, comfortable, and hassle-free cab services from Mumbai to Aurangabad. Whether you are heading for a business trip, a heritage tour, or a family visit, our skilled drivers and well-maintained vehicles ensure a safe and pleasant ride. Aurangabad, known for its historical sites like Ajanta and Ellora Caves, attracts both tourists and professionals alike. With flexible travel options and multiple vehicle choices, Deva Cabs guarantees a smooth and convenient journey from Mumbai to Aurangabad every time.',

        top: 'Top Places to Visit in Aurangabad with Deva Cabs',

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "location": "Aurangabad, Maharashtra",
    "description": "A UNESCO World Heritage Site, the Ajanta Caves are a masterpiece of Buddhist rock-cut architecture, dating back to the 2nd century BCE. The 30 caves feature intricate sculptures and murals that depict the life of Buddha and Jataka tales. Nestled in a horseshoe-shaped cliff, the caves offer a spiritual and historical retreat for art lovers, historians, and photographers."
  },
  {
    "title": "Ellora Caves",
    "location": "Aurangabad, Maharashtra",
    "description": "Ellora Caves, another UNESCO World Heritage Site, is a fusion of Buddhist, Hindu, and Jain cave temples carved between the 6th and 10th centuries. The most famous of these is the Kailasa Temple — the world’s largest monolithic rock excavation. It’s a stunning example of ancient engineering, drawing travelers, researchers, and heritage enthusiasts from across the globe."
  },
  {
    "title": "Bibi Ka Maqbara",
    "location": "Aurangabad, Maharashtra",
    "description": "Often referred to as the 'Taj of the Deccan', Bibi Ka Maqbara was built in memory of Aurangzeb’s wife, Dilras Banu Begum. This 17th-century Mughal monument resembles the Taj Mahal and is surrounded by manicured gardens and a serene ambiance. It's one of Aurangabad’s most iconic landmarks and a favorite among history buffs and tourists."
  },
  {
    "title": "Daulatabad Fort",
    "location": "Aurangabad, Maharashtra",
    "description": "Located on a conical hill, Daulatabad Fort is a marvel of medieval defense architecture. It features a maze of entry points, moats, and a steep climb to the summit, offering panoramic views of the countryside. The fort once served as the capital of the Tughlaq dynasty and remains a thrilling visit for trekkers, history lovers, and architecture enthusiasts."
  },
  {
    "title": "Grishneshwar Temple",
    "location": "Ellora, Aurangabad, Maharashtra",
    "description": "Grishneshwar Temple is one of the 12 revered Jyotirlingas dedicated to Lord Shiva. Located near Ellora Caves, this ancient temple is built in traditional South Indian style and is a significant pilgrimage site. Devotees flock here during Shravan and Mahashivratri, making it a spiritually rich stop for religious tourism."
  },
  {
    "title": "Panchakki",
    "location": "Aurangabad, Maharashtra",
    "description": "Panchakki is an 18th-century water mill built to harness energy from a nearby spring. It was used to grind grain for pilgrims and saints. The site includes a serene garden, fountains, a mosque, and a dargah complex. It’s a blend of spiritual and scientific marvel, attracting those interested in Mughal-era innovation and Islamic architecture."
  },
  {
    "title": "Aurangabad Caves",
    "location": "Aurangabad, Maharashtra",
    "description": "The Aurangabad Caves are twelve rock-cut Buddhist shrines carved during the 6th and 7th centuries. Though lesser-known compared to Ajanta and Ellora, these caves offer exquisite carvings and panoramic views of the city. They are a quiet retreat ideal for meditation, exploration, and a deep dive into early Buddhist art."
  },
  {
    "title": "Salim Ali Lake & Bird Sanctuary",
    "location": "Aurangabad, Maharashtra",
    "description": "Named after India’s renowned ornithologist, Salim Ali Lake is a haven for bird watchers and nature enthusiasts. The sanctuary around the lake is home to migratory and resident birds, especially during winter. It also features boating facilities and is a refreshing escape within the city, perfect for families and photography lovers."
  },
  {
    "title": "Himayat Bagh",
    "location": "Aurangabad, Maharashtra",
    "description": "Himayat Bagh is a 17th-century Mughal garden sprawling over 300 acres. Originally part of Aurangzeb’s palace complex, it now serves as a fruit research center and nursery. With its lush greenery, fountains, and historic charm, it's a perfect spot for peaceful strolls and heritage walks."
  },
  {
    "title": "Siddharth Garden and Zoo",
    "location": "Aurangabad, Maharashtra",
    "description": "Siddharth Garden is a well-maintained urban park featuring a small zoo, lush lawns, and play areas. It’s a favorite hangout for families and kids. Located near the central bus stand, the park also houses a prominent statue of Dr. Babasaheb Ambedkar and is ideal for a relaxing afternoon in the city."
  }
],



"services": [
    {
        "name": "Mumbai to Aurangabad Cab",
        "description": "Travel comfortably and affordably from Mumbai to Aurangabad with Deva Cabs' dedicated cab service. Whether you need a one-way trip, round trip, or a family tour, choose from our wide range of sedans, SUVs, and luxury AC vehicles. Our experienced chauffeurs ensure a safe and smooth journey, familiar with the best routes and airport transfers. Book online with transparent pricing and 24/7 customer support for a hassle-free travel experience."
    },
    {
        "name": "Outstation Cab Mumbai to Aurangabad",
        "description": "Planning an outstation trip from Mumbai to Aurangabad? Deva Cabs offers flexible and affordable outstation cab services with a choice of vehicles including sedans and SUVs. Enjoy a comfortable ride with professional drivers who know the route well, ensuring a timely and safe journey for your holiday or business trip."
    },
    {
        "name": "Aurangabad Cab Service from Mumbai",
        "description": "Deva Cabs provides reliable Aurangabad cab services from Mumbai for all your travel needs. From airport transfers to sightseeing tours, our clean and well-maintained vehicles combined with courteous drivers promise a pleasant travel experience. Book your Aurangabad cab easily online and travel with peace of mind."
    },
    {
        "name": "One Way Mumbai to Aurangabad Taxi",
        "description": "Need a one-way taxi from Mumbai to Aurangabad? Deva Cabs offers convenient one-way taxi services with upfront pricing, clean vehicles, and punctual drivers. Perfect for quick trips, business visits, or family travel."
    },
    {
        "name": "Round Trip Mumbai to Aurangabad Cab",
        "description": "Enjoy the convenience of a round trip cab service from Mumbai to Aurangabad with Deva Cabs. Ideal for tourists and business travelers who want a hassle-free round journey with the same reliable driver and vehicle throughout."
    },
    {
        "name": "Affordable Cab Mumbai to Aurangabad",
        "description": "Looking for an affordable cab from Mumbai to Aurangabad? Deva Cabs offers competitive pricing without compromising on comfort or safety. Choose from a variety of vehicle options to suit your budget and travel style."
    },
    {
        "name": "Mumbai to Aurangabad Sedan Cab",
        "description": "Travel in style and comfort with our sedan cab service from Mumbai to Aurangabad. Perfect for solo travelers, couples, or small families seeking a smooth ride with premium amenities."
    },
    {
        "name": "SUV Cab to Aurangabad from Mumbai",
        "description": "For larger groups or those wanting extra space, our SUV cab service from Mumbai to Aurangabad offers roomy seating and luggage capacity. Ideal for family trips or group travel."
    },
    {
        "name": "Chauffeur-Driven Mumbai to Aurangabad Taxi",
        "description": "Experience luxury and professionalism with our chauffeur-driven taxi services from Mumbai to Aurangabad. Our drivers are trained for excellent customer service, ensuring a comfortable and safe journey."
    },
    {
        "name": "Book Cab Online Mumbai to Aurangabad",
        "description": "Deva Cabs makes booking your Mumbai to Aurangabad cab simple and quick with our user-friendly online system. Select your vehicle, schedule your ride, and get instant confirmation."
    },
    {
        "name": "Mumbai Airport to Aurangabad Cab",
        "description": "Catch your flight or reach your destination on time with our dedicated cab service from Mumbai Airport to Aurangabad. Our drivers monitor flight timings and ensure prompt pick-up or drop-off."
    },
    {
        "name": "Luxury Cab Hire Mumbai to Aurangabad",
        "description": "For a premium travel experience, hire a luxury cab from Mumbai to Aurangabad. Our high-end vehicles offer top comfort and style, perfect for special occasions or business travelers."
    },
    {
        "name": "Family Cab to Aurangabad",
        "description": "Travel with your family comfortably in our spacious and safe cabs from Mumbai to Aurangabad. Suitable for all family sizes with ample luggage space and child-friendly options."
    },
    {
        "name": "AC Cab to Aurangabad",
        "description": "Beat the heat with our air-conditioned cab services from Mumbai to Aurangabad. All our vehicles are well-maintained with fully functional AC for your comfort."
    },
    {
        "name": "Mumbai to Aurangabad Tour Taxi",
        "description": "Explore Aurangabad and nearby attractions with our dedicated tour taxi service. Customize your itinerary and enjoy hassle-free travel with professional drivers and clean vehicles."
    }
],

"tableData": [
    ["Mumbai to Aurangabad Cab", "-Outstation Cab Mumbai to Aurangabad"],
    ["Aurangabad Cab Service from Mumbai", "-One Way Mumbai to Aurangabad Taxi"],
    ["Round Trip Mumbai to Aurangabad Cab", "-Affordable Cab Mumbai to Aurangabad"],
    ["Mumbai to Aurangabad Sedan Cab", "-SUV Cab to Aurangabad from Mumbai"],
    ["Chauffeur-Driven Mumbai to Aurangabad Taxi", "-Book Cab Online Mumbai to Aurangabad"],
    ["Mumbai Airport to Aurangabad Cab", "-Luxury Cab Hire Mumbai to Aurangabad"],
    ["Family Cab to Aurangabad", "-AC Cab to Aurangabad"],
    ["Mumbai to Aurangabad Tour Taxi", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable and On-Time Pickup from Mumbai",
    "WhyChoosedescription": "Deva Cabs ensures punctual pickups from anywhere in Mumbai for your trip to Aurangabad. Whether you're heading to historic sites or business meetings, start your journey on time without any hassle."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Long Drives",
    "WhyChoosedescription": "Our well-maintained, air-conditioned vehicles provide a comfortable ride from Mumbai to Aurangabad. With ample legroom and luggage space, enjoy a smooth journey no matter how long the trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Aurangabad Routes",
    "WhyChoosedescription": "Our professional drivers know the best routes to Aurangabad, including stops at popular tourist spots like Ajanta and Ellora Caves. Relax as they navigate safely and efficiently."
  },
  {
    "WhyChooseheading": "Transparent and Fair Fare Structure",
    "WhyChoosedescription": "No hidden charges or surge pricing. Deva Cabs provides clear fare details upfront for your Mumbai to Aurangabad ride, so you can travel worry-free."
  },
  {
    "WhyChooseheading": "Available Anytime for Your Convenience",
    "WhyChoosedescription": "Whether it’s an early morning departure or a late-night return, Deva Cabs is available 24/7 for trips between Mumbai and Aurangabad. Just book through our app, website, or call center."
  },
  {
    "WhyChooseheading": "Highest Safety Standards for Peace of Mind",
    "WhyChoosedescription": "Your safety is paramount. All cabs are equipped with GPS tracking, sanitized interiors, and driven by trained, responsible drivers to ensure a secure journey."
  },
  {
    "WhyChooseheading": "Fast and Easy Booking Process",
    "WhyChoosedescription": "Book your Mumbai to Aurangabad cab quickly with our intuitive app or website. Get instant confirmations and real-time driver tracking for a seamless experience."
  },
  {
    "WhyChooseheading": "Custom Travel Solutions Tailored to Your Needs",
    "WhyChoosedescription": "From one-way trips to round trips and hourly rentals, Deva Cabs offers flexible travel options for your Mumbai to Aurangabad journey. Perfect for business, tourism, or personal travel."
  }
]




















    }




const faqData = [
  {
    question: "Can I book a cab from Mumbai to Aurangabad with Deva Cabs?",
    answer: "Yes, Deva Cabs offers reliable and comfortable cab services from Mumbai to Aurangabad. You can book your ride easily via our website, mobile app, or by contacting our customer support."
  },
  {
    question: "What are the vehicle options for Mumbai to Aurangabad trips?",
    answer: "We offer a variety of vehicle options including hatchbacks, sedans, SUVs, and premium cars for a comfortable ride from Mumbai to Aurangabad."
  },
  {
    question: "How long does the journey from Mumbai to Aurangabad take?",
    answer: "The journey duration from Mumbai to Aurangabad typically ranges between 5 to 7 hours, depending on traffic and the specific route taken."
  },
  {
    question: "Is there an option for a round trip from Mumbai to Aurangabad?",
    answer: "Yes, you can book a round trip for your journey to Aurangabad, and we will ensure timely pick-up and drop-off based on your schedule."
  },
  {
    question: "Can I pre-schedule my Mumbai to Aurangabad ride?",
    answer: "Yes, you can pre-schedule your ride from Mumbai to Aurangabad through our booking portal or app. Choose your preferred date and time for guaranteed pickup."
  },
  {
    question: "What are the payment options for booking a Mumbai to Aurangabad cab?",
    answer: "We accept cash, credit/debit cards, UPI, and online payments through our mobile app or website for your Mumbai to Aurangabad ride."
  },
  {
    question: "Are the drivers for Mumbai to Aurangabad rides experienced?",
    answer: "Yes, all our drivers are experienced, verified, and familiar with the Mumbai to Aurangabad route to ensure a safe and smooth journey."
  },
  {
    question: "Is it safe to travel from Mumbai to Aurangabad with Deva Cabs?",
    answer: "Absolutely! All our cabs are GPS-enabled, and we ensure the highest safety standards, with professional drivers dedicated to your comfort."
  }
];

const testimonialData = [
  {
    id: 1,
    name: 'Mr. Rohit Agrawal',
    role: 'Corporate Executive',
    review: 'I travel frequently from Mumbai to Aurangabad for work, and Deva Cabs provides a hassle-free and comfortable experience. The drivers are always punctual, and the ride is smooth every time.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 2,
    name: 'Ms. Anjali Kaur',
    role: 'Tourist',
    review: 'Had a great trip from Mumbai to Aurangabad with Deva Cabs. The car was clean, and the driver was very knowledgeable about the area. Would definitely recommend it for a comfortable journey!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];


























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Aurangabad Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-aurangabad-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Aurangabad cab with Deva Cabs for a comfortable and reliable journey. Choose from hatchbacks, sedans, SUVs, and tempo travellers for one-way or round trips. Professional drivers and affordable fares guaranteed.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2905"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3899",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-aurangabad-cab"
  }
};








    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Aurangabad Cab | One Way & Round Trip Taxi </title>
  <meta 
    name="description" 
    content="Book Mumbai to Aurangabad cab with Deva Cabs for safe and affordable travel. One-way and round trip options available with hatchbacks, sedans, SUVs, and tempo travellers. Professional drivers and 24/7 booking." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Aurangabad Cab, Cab from Mumbai to Aurangabad, One Way Taxi Mumbai to Aurangabad, Aurangabad Cab Service, Mumbai to Aurangabad Car Rental, Deva Cabs Aurangabad, SUV Sedan Tempo Traveller Mumbai to Aurangabad, Affordable Taxi Mumbai to Aurangabad, Online Cab Booking Mumbai Aurangabad" 
  />
  <link rel="canonical" href="https://devacab.com/mumbai-to-aurangabad-cab" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/63.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitoaurangabadcab;